import type {ReactElement} from 'react';
import React from 'react';
import {Option} from '@Components/contextual-menu/components/option';
import type { TabsToggleProps} from '@Components/tabs-toggle';
import {TabsToggle} from '@Components/tabs-toggle';

interface ContextualMenuTabToggleOptionProps extends TabsToggleProps {
  id: string;
  label: string;
  optionClassName?: string;
}

export function ContextualMenuTabToggleOption({optionClassName = '', className = '', ...props}: ContextualMenuTabToggleOptionProps): ReactElement | null {
  return (
    <Option
      key={props.id}
      label={props.label}
      className={optionClassName}
      optionControl={
        <TabsToggle
          variant={props.variant}
          size={props.size}
          className={className}
          data={props.data}
          selectedId={props.selectedId}
          onClick={(id: string): void => {
            props.onClick(id);
          }}
        />
      }
    />
  );
}
